/**
 * High-traffic deposit / withdraw / inbox strings for locales that do not
 * ship a full `panelDepositWithdrawInbox` block (merged after `en` so these
 * override English fallbacks).
 */
export const panelDwiOverrides = {
  fr: {
    'user.deposit.title': 'Dépôt',
    'user.deposit.tab.crypto': 'Dépôt crypto',
    'user.deposit.tab.evoucher': 'E-Voucher',
    'user.deposit.network.label': 'Réseau',
    'user.deposit.network.soon': 'Bientôt',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': 'Chargement de l’adresse de dépôt…',
    'user.deposit.crypto.checkForDeposit': 'Vérifier le dépôt',
    'user.deposit.crypto.checking': 'Vérification…',
    'user.deposit.crypto.checkFound': 'Nouveau dépôt détecté ! En attente de confirmations.',
    'user.deposit.crypto.checkNone': 'Aucun nouveau dépôt. Réessayez dans un instant.',
    'user.deposit.card.title': 'Votre adresse de dépôt',
    'user.deposit.card.sendOnly': 'Envoyez uniquement des USDT TRC20 à cette adresse',
    'user.deposit.card.networkLine': 'Réseau : USDT TRC20 uniquement',
    'user.deposit.card.confirmationsLine': '{{n}} confirmations requises (~1 min)',
    'user.deposit.card.valid24h': 'Adresse valable 24 heures',
    'user.deposit.card.warningWrongToken':
      'Envoyez uniquement des USDT TRC20. Tout autre jeton ou réseau peut entraîner une perte définitive.',
    'user.deposit.card.scanQr': 'Scanner le QR code',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': 'Expire dans {{h}}h {{m}}m {{s}}s',
    'user.deposit.expired': 'Expiré',
    'user.deposit.history.title': 'Historique des dépôts',
    'user.deposit.history.filter.all': 'Tous',
    'user.deposit.history.filter.pending': 'En attente',
    'user.deposit.history.filter.confirming': 'Confirmation',
    'user.deposit.history.filter.completed': 'Terminé',
    'user.deposit.history.filter.failed': 'Échoué',
    'user.deposit.history.col.date': 'Date',
    'user.deposit.history.col.amount': 'Montant',
    'user.deposit.history.col.status': 'Statut',
    'user.deposit.history.col.confirmations': 'Confirmations',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': 'Retrait',
    'user.withdraw.form.title': 'Demander un retrait',
    'user.withdraw.form.method': 'Méthode de retrait',
    'user.withdraw.form.selectMethod': 'Choisir une méthode',
    'user.withdraw.form.walletAddress': 'Adresse du portefeuille',
    'user.withdraw.form.request': 'Demander le retrait',
    'user.withdraw.rules.title': 'Règles de retrait',
    'user.withdraw.rules.cryptoMining': 'Mining crypto',
    'user.withdraw.rules.cryptoMiningPeriod': 'Tous les 3 mois',
    'user.withdraw.rules.bullion': 'Commerce de métaux précieux',
    'user.withdraw.rules.bullionPeriod': 'Tous les 8 mois',
    'user.withdraw.rules.pharma': 'Pharmaceutique',
    'user.withdraw.rules.pharmaPeriod': 'Fin de la période du plan',
    'user.withdraw.rules.supported': 'Moyens pris en charge',
    'user.withdraw.rules.feeNote':
      'Des frais de plateforme de {{pct}}% s\'appliquent aux retraits portefeuille. L\'annulation anticipée d\'un plan utilise des frais distincts.',
    'user.withdraw.rules.noFeeNote':
      'Aucun frais de plateforme sur les retraits portefeuille. L\'annulation anticipée d\'un plan utilise des frais distincts.',
    'user.withdraw.rules.processingNote':
      'Les demandes sont traitées sous 24 à 48 heures après approbation.',
    'user.withdraw.history.title': 'Historique des retraits',
    'user.withdraw.history.exportCsv': 'Exporter CSV',
    'user.withdraw.history.col.date': 'Date',
    'user.withdraw.history.col.amount': 'Montant',
    'user.withdraw.history.col.method': 'Méthode',
    'user.withdraw.history.col.fee': 'Frais',
    'user.withdraw.history.col.net': 'Montant net',
    'user.withdraw.history.col.status': 'Statut',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': 'Actions',
    'user.notifications.title': 'Notifications',
    'inbox.summary': '{{total}} au total · {{unread}} non lues',
    'inbox.refresh': 'Actualiser',
    'inbox.markAllRead': 'Tout marquer comme lu',
  },
  ar: {
    'user.deposit.title': 'إيداع',
    'user.deposit.tab.crypto': 'إيداع بالعملة المشفرة',
    'user.deposit.tab.evoucher': 'قسيمة إلكترونية',
    'user.deposit.network.label': 'الشبكة',
    'user.deposit.network.soon': 'قريباً',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': 'جاري تحميل عنوان الإيداع…',
    'user.deposit.crypto.checkForDeposit': 'التحقق من الإيداع',
    'user.deposit.crypto.checking': 'جاري التحقق…',
    'user.deposit.crypto.checkFound': 'تم رصد إيداع جديد! بانتظار التأكيدات.',
    'user.deposit.crypto.checkNone': 'لا يوجد إيداع جديد. حاول مرة أخرى بعد قليل.',
    'user.deposit.card.title': 'عنوان الإيداع الخاص بك',
    'user.deposit.card.sendOnly': 'أرسل USDT TRC20 فقط إلى هذا العنوان',
    'user.deposit.card.networkLine': 'الشبكة: USDT TRC20 فقط',
    'user.deposit.card.confirmationsLine': 'مطلوب {{n}} تأكيداً (~1 دقيقة)',
    'user.deposit.card.valid24h': 'العنوان صالح لمدة 24 ساعة',
    'user.deposit.card.warningWrongToken':
      'أرسل USDT TRC20 فقط. أي رمز أو شبكة أخرى قد يؤدي إلى خسارة دائمة للأموال.',
    'user.deposit.card.scanQr': 'مسح رمز QR',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': 'ينتهي خلال {{h}}س {{m}}د {{s}}ث',
    'user.deposit.expired': 'منتهٍ',
    'user.deposit.history.title': 'سجل الإيداعات',
    'user.deposit.history.filter.all': 'الكل',
    'user.deposit.history.filter.pending': 'معلق',
    'user.deposit.history.filter.confirming': 'قيد التأكيد',
    'user.deposit.history.filter.completed': 'مكتمل',
    'user.deposit.history.filter.failed': 'فشل',
    'user.deposit.history.col.date': 'التاريخ',
    'user.deposit.history.col.amount': 'المبلغ',
    'user.deposit.history.col.status': 'الحالة',
    'user.deposit.history.col.confirmations': 'التأكيدات',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': 'سحب',
    'user.withdraw.form.title': 'طلب سحب',
    'user.withdraw.form.method': 'طريقة السحب',
    'user.withdraw.form.selectMethod': 'اختر الطريقة',
    'user.withdraw.form.walletAddress': 'عنوان المحفظة',
    'user.withdraw.form.request': 'إرسال طلب السحب',
    'user.withdraw.rules.title': 'قواعد السحب',
    'user.withdraw.rules.cryptoMining': 'تعدين العملات',
    'user.withdraw.rules.cryptoMiningPeriod': 'كل 3 أشهر',
    'user.withdraw.rules.bullion': 'تجارة السبائك',
    'user.withdraw.rules.bullionPeriod': 'كل 8 أشهر',
    'user.withdraw.rules.pharma': 'الأدوية',
    'user.withdraw.rules.pharmaPeriod': 'نهاية فترة الخطة',
    'user.withdraw.rules.supported': 'الطرق المدعومة',
    'user.withdraw.rules.feeNote':
      'تُطبَّق رسوم منصة بنسبة {{pct}}% على سحوبات المحفظة. إلغاء الخطة المبكر له رسوم منفصلة.',
    'user.withdraw.rules.noFeeNote':
      'لا توجد رسوم منصة على سحوبات المحفظة. إلغاء الخطة المبكر له رسوم منفصلة.',
    'user.withdraw.rules.processingNote':
      'تُعالج طلبات السحب خلال 24–48 ساعة بعد الموافقة.',
    'user.withdraw.history.title': 'سجل السحوبات',
    'user.withdraw.history.exportCsv': 'تصدير CSV',
    'user.withdraw.history.col.date': 'التاريخ',
    'user.withdraw.history.col.amount': 'المبلغ',
    'user.withdraw.history.col.method': 'الطريقة',
    'user.withdraw.history.col.fee': 'الرسوم',
    'user.withdraw.history.col.net': 'الصافي',
    'user.withdraw.history.col.status': 'الحالة',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': 'إجراءات',
    'user.notifications.title': 'الإشعارات',
    'inbox.summary': '{{total}} إجمالي · {{unread}} غير مقروء',
    'inbox.refresh': 'تحديث',
    'inbox.markAllRead': 'تعليم الكل كمقروء',
  },
  ja: {
    'user.deposit.title': '入金',
    'user.deposit.tab.crypto': '暗号入金',
    'user.deposit.tab.evoucher': 'Eバウチャー',
    'user.deposit.network.label': 'ネットワーク',
    'user.deposit.network.soon': '近日対応',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': '入金アドレスを読み込み中…',
    'user.deposit.crypto.checkForDeposit': '入金を確認',
    'user.deposit.crypto.checking': '確認中…',
    'user.deposit.crypto.checkFound': '新しい入金を検出しました。確認待ちです。',
    'user.deposit.crypto.checkNone': '新しい入金はありません。しばらくしてから再度お試しください。',
    'user.deposit.card.title': 'あなたの入金アドレス',
    'user.deposit.card.sendOnly': 'このアドレスには USDT TRC20 のみ送金してください',
    'user.deposit.card.networkLine': 'ネットワーク: USDT TRC20 のみ',
    'user.deposit.card.confirmationsLine': '{{n}} 回の確認が必要（約1分）',
    'user.deposit.card.valid24h': 'アドレスの有効期限は24時間です',
    'user.deposit.card.warningWrongToken':
      'USDT TRC20 のみ送金してください。他のトークンやネットワークは資金を永久に失う可能性があります。',
    'user.deposit.card.scanQr': 'QRコードをスキャン',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': '残り {{h}}時間 {{m}}分 {{s}}秒',
    'user.deposit.expired': '期限切れ',
    'user.deposit.history.title': '入金履歴',
    'user.deposit.history.filter.all': 'すべて',
    'user.deposit.history.filter.pending': '保留',
    'user.deposit.history.filter.confirming': '確認中',
    'user.deposit.history.filter.completed': '完了',
    'user.deposit.history.filter.failed': '失敗',
    'user.deposit.history.col.date': '日付',
    'user.deposit.history.col.amount': '金額',
    'user.deposit.history.col.status': 'ステータス',
    'user.deposit.history.col.confirmations': '確認',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': '出金',
    'user.withdraw.form.title': '出金を申請',
    'user.withdraw.form.method': '出金方法',
    'user.withdraw.form.selectMethod': '方法を選択',
    'user.withdraw.form.walletAddress': 'ウォレットアドレス',
    'user.withdraw.form.request': '出金を申請',
    'user.withdraw.rules.title': '出金ルール',
    'user.withdraw.rules.cryptoMining': '暗号マイニング',
    'user.withdraw.rules.cryptoMiningPeriod': '3か月ごと',
    'user.withdraw.rules.bullion': '地金取引',
    'user.withdraw.rules.bullionPeriod': '8か月ごと',
    'user.withdraw.rules.pharma': '医薬品',
    'user.withdraw.rules.pharmaPeriod': 'プラン期間終了時',
    'user.withdraw.rules.supported': '対応方法',
    'user.withdraw.rules.feeNote':
      'ウォレット出金には{{pct}}%のプラットフォーム手数料がかかります。プランの早期解約は別料金です。',
    'user.withdraw.rules.noFeeNote':
      'ウォレット出金にプラットフォーム手数料はかかりません。プランの早期解約は別料金です。',
    'user.withdraw.rules.processingNote': '出金申請は承認後24〜48時間以内に処理されます。',
    'user.withdraw.history.title': '出金履歴',
    'user.withdraw.history.exportCsv': 'CSVをエクスポート',
    'user.withdraw.history.col.date': '日付',
    'user.withdraw.history.col.amount': '金額',
    'user.withdraw.history.col.method': '方法',
    'user.withdraw.history.col.fee': '手数料',
    'user.withdraw.history.col.net': '受取額',
    'user.withdraw.history.col.status': 'ステータス',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': '操作',
    'user.notifications.title': '通知',
    'inbox.summary': '合計 {{total}} 件 · 未読 {{unread}} 件',
    'inbox.refresh': '更新',
    'inbox.markAllRead': 'すべて既読にする',
  },
  ko: {
    'user.deposit.title': '입금',
    'user.deposit.tab.crypto': '암호화폐 입금',
    'user.deposit.tab.evoucher': 'E-바우처',
    'user.deposit.network.label': '네트워크',
    'user.deposit.network.soon': '곧 제공',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': '입금 주소 불러오는 중…',
    'user.deposit.crypto.checkForDeposit': '입금 확인',
    'user.deposit.crypto.checking': '확인 중…',
    'user.deposit.crypto.checkFound': '새 입금이 감지되었습니다. 확인 대기 중입니다.',
    'user.deposit.crypto.checkNone': '새 입금이 없습니다. 잠시 후 다시 시도하세요.',
    'user.deposit.card.title': '내 입금 주소',
    'user.deposit.card.sendOnly': '이 주소로는 USDT TRC20만 보내세요',
    'user.deposit.card.networkLine': '네트워크: USDT TRC20만',
    'user.deposit.card.confirmationsLine': '{{n}}회 확인 필요(약 1분)',
    'user.deposit.card.valid24h': '주소는 24시간 유효합니다',
    'user.deposit.card.warningWrongToken':
      'USDT TRC20만 보내세요. 다른 토큰이나 네트워크는 자금을 영구적으로 잃을 수 있습니다.',
    'user.deposit.card.scanQr': 'QR 코드 스캔',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': '{{h}}시간 {{m}}분 {{s}}초 남음',
    'user.deposit.expired': '만료됨',
    'user.deposit.history.title': '입금 내역',
    'user.deposit.history.filter.all': '전체',
    'user.deposit.history.filter.pending': '대기',
    'user.deposit.history.filter.confirming': '확인 중',
    'user.deposit.history.filter.completed': '완료',
    'user.deposit.history.filter.failed': '실패',
    'user.deposit.history.col.date': '날짜',
    'user.deposit.history.col.amount': '금액',
    'user.deposit.history.col.status': '상태',
    'user.deposit.history.col.confirmations': '확인',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': '출금',
    'user.withdraw.form.title': '출금 요청',
    'user.withdraw.form.method': '출금 방법',
    'user.withdraw.form.selectMethod': '방법 선택',
    'user.withdraw.form.walletAddress': '지갑 주소',
    'user.withdraw.form.request': '출금 요청',
    'user.withdraw.rules.title': '출금 규정',
    'user.withdraw.rules.cryptoMining': '암호화폐 채굴',
    'user.withdraw.rules.cryptoMiningPeriod': '3개월마다',
    'user.withdraw.rules.bullion': '귀금속 거래',
    'user.withdraw.rules.bullionPeriod': '8개월마다',
    'user.withdraw.rules.pharma': '의약품',
    'user.withdraw.rules.pharmaPeriod': '플랜 기간 종료 시',
    'user.withdraw.rules.supported': '지원 방식',
    'user.withdraw.rules.feeNote':
      '지갑 출금에 {{pct}}% 플랫폼 수수료가 적용됩니다. 플랜 조기 해지는 별도 수수료입니다.',
    'user.withdraw.rules.noFeeNote':
      '지갑 출금에 플랫폼 수수료가 없습니다. 플랜 조기 해지는 별도 수수료입니다.',
    'user.withdraw.rules.processingNote': '출금 요청은 승인 후 24~48시간 이내에 처리됩니다.',
    'user.withdraw.history.title': '출금 내역',
    'user.withdraw.history.exportCsv': 'CSV보내기',
    'user.withdraw.history.col.date': '날짜',
    'user.withdraw.history.col.amount': '금액',
    'user.withdraw.history.col.method': '방법',
    'user.withdraw.history.col.fee': '수수료',
    'user.withdraw.history.col.net': '순금액',
    'user.withdraw.history.col.status': '상태',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': '작업',
    'user.notifications.title': '알림',
    'inbox.summary': '총 {{total}}건 · 읽지 않음 {{unread}}건',
    'inbox.refresh': '새로고침',
    'inbox.markAllRead': '모두 읽음',
  },

  'zh-CN': {
    'user.deposit.title': '存款',
    'user.deposit.tab.crypto': '加密货币存款',
    'user.deposit.tab.evoucher': '电子券',
    'user.deposit.network.label': '网络',
    'user.deposit.network.soon': '即将推出',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': '正在加载存款地址…',
    'user.deposit.crypto.checkForDeposit': '检查存款',
    'user.deposit.crypto.checking': '检查中…',
    'user.deposit.crypto.checkFound': '检测到新存款！等待确认。',
    'user.deposit.crypto.checkNone': '暂无新存款，请稍后重试。',
    'user.deposit.card.title': '您的存款地址',
    'user.deposit.card.sendOnly': '请仅向此地址发送 USDT TRC20',
    'user.deposit.card.networkLine': '网络：仅 USDT TRC20',
    'user.deposit.card.confirmationsLine': '需要 {{n}} 次确认（约 1 分钟）',
    'user.deposit.card.valid24h': '地址有效期 24 小时',
    'user.deposit.card.warningWrongToken':
      '仅发送 USDT TRC20。发送其他代币或网络可能导致资金永久丢失。',
    'user.deposit.card.scanQr': '扫描二维码',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': '剩余 {{h}} 小时 {{m}} 分 {{s}} 秒',
    'user.deposit.expired': '已过期',
    'user.deposit.history.title': '存款记录',
    'user.deposit.history.filter.all': '全部',
    'user.deposit.history.filter.pending': '待处理',
    'user.deposit.history.filter.confirming': '确认中',
    'user.deposit.history.filter.completed': '已完成',
    'user.deposit.history.filter.failed': '失败',
    'user.deposit.history.col.date': '日期',
    'user.deposit.history.col.amount': '金额',
    'user.deposit.history.col.status': '状态',
    'user.deposit.history.col.confirmations': '确认数',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': '提现',
    'user.withdraw.form.title': '申请提现',
    'user.withdraw.form.method': '提现方式',
    'user.withdraw.form.selectMethod': '选择方式',
    'user.withdraw.form.walletAddress': '钱包地址',
    'user.withdraw.form.request': '提交提现申请',
    'user.withdraw.rules.title': '提现规则',
    'user.withdraw.rules.cryptoMining': '加密货币挖矿',
    'user.withdraw.rules.cryptoMiningPeriod': '每 3 个月',
    'user.withdraw.rules.bullion': '贵金属交易',
    'user.withdraw.rules.bullionPeriod': '每 8 个月',
    'user.withdraw.rules.pharma': '医药',
    'user.withdraw.rules.pharmaPeriod': '计划期结束时',
    'user.withdraw.rules.supported': '支持的方式',
    'user.withdraw.rules.feeNote':
      '钱包提现收取 {{pct}}% 平台手续费。提前取消计划另有单独费用。',
    'user.withdraw.rules.noFeeNote':
      '钱包提现无平台手续费。提前取消计划另有单独费用。',
    'user.withdraw.rules.processingNote': '提现申请在批准后 24–48 小时内处理。',
    'user.withdraw.history.title': '提现记录',
    'user.withdraw.history.exportCsv': '导出 CSV',
    'user.withdraw.history.col.date': '日期',
    'user.withdraw.history.col.amount': '金额',
    'user.withdraw.history.col.method': '方式',
    'user.withdraw.history.col.fee': '手续费',
    'user.withdraw.history.col.net': '净额',
    'user.withdraw.history.col.status': '状态',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': '操作',
    'user.notifications.title': '通知',
    'inbox.summary': '共 {{total}} 条 · 未读 {{unread}} 条',
    'inbox.refresh': '刷新',
    'inbox.markAllRead': '全部标为已读',
  },

  pt: {
    'user.deposit.title': 'Depósito',
    'user.deposit.tab.crypto': 'Depósito em cripto',
    'user.deposit.tab.evoucher': 'E-Voucher',
    'user.deposit.network.label': 'Rede',
    'user.deposit.network.soon': 'Em breve',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': 'A carregar endereço de depósito…',
    'user.deposit.crypto.checkForDeposit': 'Verificar depósito',
    'user.deposit.crypto.checking': 'A verificar…',
    'user.deposit.crypto.checkFound': 'Novo depósito detetado! A aguardar confirmações.',
    'user.deposit.crypto.checkNone': 'Sem novos depósitos. Tente novamente em breve.',
    'user.deposit.card.title': 'O seu endereço de depósito',
    'user.deposit.card.sendOnly': 'Envie apenas USDT TRC20 para este endereço',
    'user.deposit.card.networkLine': 'Rede: apenas USDT TRC20',
    'user.deposit.card.confirmationsLine': '{{n}} confirmações necessárias (~1 min)',
    'user.deposit.card.valid24h': 'Endereço válido por 24 horas',
    'user.deposit.card.warningWrongToken':
      'Envie apenas USDT TRC20. Outros tokens ou redes podem causar perda permanente.',
    'user.deposit.card.scanQr': 'Digitalizar código QR',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': 'Expira em {{h}}h {{m}}m {{s}}s',
    'user.deposit.expired': 'Expirado',
    'user.deposit.history.title': 'Histórico de depósitos',
    'user.deposit.history.filter.all': 'Todos',
    'user.deposit.history.filter.pending': 'Pendente',
    'user.deposit.history.filter.confirming': 'A confirmar',
    'user.deposit.history.filter.completed': 'Concluído',
    'user.deposit.history.filter.failed': 'Falhou',
    'user.deposit.history.col.date': 'Data',
    'user.deposit.history.col.amount': 'Montante',
    'user.deposit.history.col.status': 'Estado',
    'user.deposit.history.col.confirmations': 'Confirmações',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': 'Levantamento',
    'user.withdraw.form.title': 'Pedir levantamento',
    'user.withdraw.form.method': 'Método de levantamento',
    'user.withdraw.form.selectMethod': 'Selecionar método',
    'user.withdraw.form.walletAddress': 'Endereço da carteira',
    'user.withdraw.form.request': 'Pedir levantamento',
    'user.withdraw.rules.title': 'Regras de levantamento',
    'user.withdraw.rules.cryptoMining': 'Mineração cripto',
    'user.withdraw.rules.cryptoMiningPeriod': 'A cada 3 meses',
    'user.withdraw.rules.bullion': 'Negociação de metais',
    'user.withdraw.rules.bullionPeriod': 'A cada 8 meses',
    'user.withdraw.rules.pharma': 'Farmacêutica',
    'user.withdraw.rules.pharmaPeriod': 'Fim do período do plano',
    'user.withdraw.rules.supported': 'Métodos suportados',
    'user.withdraw.rules.feeNote':
      'Aplica-se uma taxa de plataforma de {{pct}}% aos levantamentos. O cancelamento antecipado do plano tem taxa separada.',
    'user.withdraw.rules.noFeeNote':
      'Sem taxa de plataforma nos levantamentos. O cancelamento antecipado do plano tem taxa separada.',
    'user.withdraw.rules.processingNote':
      'Os pedidos são processados em 24–48 horas após aprovação.',
    'user.withdraw.history.title': 'Histórico de levantamentos',
    'user.withdraw.history.exportCsv': 'Exportar CSV',
    'user.withdraw.history.col.date': 'Data',
    'user.withdraw.history.col.amount': 'Montante',
    'user.withdraw.history.col.method': 'Método',
    'user.withdraw.history.col.fee': 'Taxa',
    'user.withdraw.history.col.net': 'Líquido',
    'user.withdraw.history.col.status': 'Estado',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': 'Ações',
    'user.notifications.title': 'Notificações',
    'inbox.summary': '{{total}} no total · {{unread}} não lidas',
    'inbox.refresh': 'Atualizar',
    'inbox.markAllRead': 'Marcar tudo como lido',
  },

  it: {
    'user.deposit.title': 'Deposito',
    'user.deposit.tab.crypto': 'Deposito crypto',
    'user.deposit.tab.evoucher': 'E-Voucher',
    'user.deposit.network.label': 'Rete',
    'user.deposit.network.soon': 'Prossimamente',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': 'Caricamento indirizzo di deposito…',
    'user.deposit.crypto.checkForDeposit': 'Verifica deposito',
    'user.deposit.crypto.checking': 'Verifica in corso…',
    'user.deposit.crypto.checkFound': 'Nuovo deposito rilevato! In attesa di conferme.',
    'user.deposit.crypto.checkNone': 'Nessun nuovo deposito. Riprova tra poco.',
    'user.deposit.card.title': 'Il tuo indirizzo di deposito',
    'user.deposit.card.sendOnly': 'Invia solo USDT TRC20 a questo indirizzo',
    'user.deposit.card.networkLine': 'Rete: solo USDT TRC20',
    'user.deposit.card.confirmationsLine': '{{n}} conferme richieste (~1 min)',
    'user.deposit.card.valid24h': 'Indirizzo valido per 24 ore',
    'user.deposit.card.warningWrongToken':
      'Invia solo USDT TRC20. Altri token o reti possono causare perdita permanente.',
    'user.deposit.card.scanQr': 'Scansiona QR',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': 'Scade tra {{h}}h {{m}}m {{s}}s',
    'user.deposit.expired': 'Scaduto',
    'user.deposit.history.title': 'Cronologia depositi',
    'user.deposit.history.filter.all': 'Tutti',
    'user.deposit.history.filter.pending': 'In sospeso',
    'user.deposit.history.filter.confirming': 'In conferma',
    'user.deposit.history.filter.completed': 'Completato',
    'user.deposit.history.filter.failed': 'Fallito',
    'user.deposit.history.col.date': 'Data',
    'user.deposit.history.col.amount': 'Importo',
    'user.deposit.history.col.status': 'Stato',
    'user.deposit.history.col.confirmations': 'Conferme',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': 'Prelievo',
    'user.withdraw.form.title': 'Richiedi prelievo',
    'user.withdraw.form.method': 'Metodo di prelievo',
    'user.withdraw.form.selectMethod': 'Seleziona metodo',
    'user.withdraw.form.walletAddress': 'Indirizzo wallet',
    'user.withdraw.form.request': 'Richiedi prelievo',
    'user.withdraw.rules.title': 'Regole di prelievo',
    'user.withdraw.rules.cryptoMining': 'Crypto mining',
    'user.withdraw.rules.cryptoMiningPeriod': 'Ogni 3 mesi',
    'user.withdraw.rules.bullion': 'Commercio metalli',
    'user.withdraw.rules.bullionPeriod': 'Ogni 8 mesi',
    'user.withdraw.rules.pharma': 'Farmaceutica',
    'user.withdraw.rules.pharmaPeriod': 'Fine periodo del piano',
    'user.withdraw.rules.supported': 'Metodi supportati',
    'user.withdraw.rules.feeNote':
      'Su i prelievi wallet si applica una commissione piattaforma del {{pct}}%. La cancellazione anticipata del piano ha una commissione separata.',
    'user.withdraw.rules.noFeeNote':
      'Nessuna commissione piattaforma sui prelievi wallet. La cancellazione anticipata del piano ha una commissione separata.',
    'user.withdraw.rules.processingNote':
      'Le richieste sono elaborate entro 24–48 ore dopo l’approvazione.',
    'user.withdraw.history.title': 'Cronologia prelievi',
    'user.withdraw.history.exportCsv': 'Esporta CSV',
    'user.withdraw.history.col.date': 'Data',
    'user.withdraw.history.col.amount': 'Importo',
    'user.withdraw.history.col.method': 'Metodo',
    'user.withdraw.history.col.fee': 'Commissione',
    'user.withdraw.history.col.net': 'Netto',
    'user.withdraw.history.col.status': 'Stato',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': 'Azioni',
    'user.notifications.title': 'Notifiche',
    'inbox.summary': '{{total}} in totale · {{unread}} non lette',
    'inbox.refresh': 'Aggiorna',
    'inbox.markAllRead': 'Segna tutto come letto',
  },

  ru: {
    'user.deposit.title': 'Депозит',
    'user.deposit.tab.crypto': 'Криптодепозит',
    'user.deposit.tab.evoucher': 'E-ваучер',
    'user.deposit.network.label': 'Сеть',
    'user.deposit.network.soon': 'Скоро',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': 'Загрузка адреса депозита…',
    'user.deposit.crypto.checkForDeposit': 'Проверить депозит',
    'user.deposit.crypto.checking': 'Проверка…',
    'user.deposit.crypto.checkFound': 'Обнаружен новый депозит! Ожидаются подтверждения.',
    'user.deposit.crypto.checkNone': 'Новых депозитов нет. Попробуйте позже.',
    'user.deposit.card.title': 'Ваш адрес для депозита',
    'user.deposit.card.sendOnly': 'Отправляйте только USDT TRC20 на этот адрес',
    'user.deposit.card.networkLine': 'Сеть: только USDT TRC20',
    'user.deposit.card.confirmationsLine': 'Требуется {{n}} подтверждений (~1 мин)',
    'user.deposit.card.valid24h': 'Адрес действителен 24 часа',
    'user.deposit.card.warningWrongToken':
      'Отправляйте только USDT TRC20. Другие токены или сети могут привести к безвозвратной потере.',
    'user.deposit.card.scanQr': 'Сканировать QR',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': 'Истекает через {{h}}ч {{m}}м {{s}}с',
    'user.deposit.expired': 'Истёк',
    'user.deposit.history.title': 'История депозитов',
    'user.deposit.history.filter.all': 'Все',
    'user.deposit.history.filter.pending': 'В ожидании',
    'user.deposit.history.filter.confirming': 'Подтверждение',
    'user.deposit.history.filter.completed': 'Завершено',
    'user.deposit.history.filter.failed': 'Ошибка',
    'user.deposit.history.col.date': 'Дата',
    'user.deposit.history.col.amount': 'Сумма',
    'user.deposit.history.col.status': 'Статус',
    'user.deposit.history.col.confirmations': 'Подтверждения',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': 'Вывод',
    'user.withdraw.form.title': 'Запросить вывод',
    'user.withdraw.form.method': 'Способ вывода',
    'user.withdraw.form.selectMethod': 'Выберите способ',
    'user.withdraw.form.walletAddress': 'Адрес кошелька',
    'user.withdraw.form.request': 'Запросить вывод',
    'user.withdraw.rules.title': 'Правила вывода',
    'user.withdraw.rules.cryptoMining': 'Криптомайнинг',
    'user.withdraw.rules.cryptoMiningPeriod': 'Каждые 3 месяца',
    'user.withdraw.rules.bullion': 'Торговля металлами',
    'user.withdraw.rules.bullionPeriod': 'Каждые 8 месяцев',
    'user.withdraw.rules.pharma': 'Фармацевтика',
    'user.withdraw.rules.pharmaPeriod': 'Конец срока плана',
    'user.withdraw.rules.supported': 'Поддерживаемые способы',
    'user.withdraw.rules.feeNote':
      'На выводы действует комиссия платформы {{pct}}%. Досрочная отмена плана — отдельная комиссия.',
    'user.withdraw.rules.noFeeNote':
      'Вывод на кошелёк без комиссии платформы. Досрочная отмена плана — отдельная комиссия.',
    'user.withdraw.rules.processingNote':
      'Заявки обрабатываются в течение 24–48 часов после одобрения.',
    'user.withdraw.history.title': 'История выводов',
    'user.withdraw.history.exportCsv': 'Экспорт CSV',
    'user.withdraw.history.col.date': 'Дата',
    'user.withdraw.history.col.amount': 'Сумма',
    'user.withdraw.history.col.method': 'Способ',
    'user.withdraw.history.col.fee': 'Комиссия',
    'user.withdraw.history.col.net': 'К получению',
    'user.withdraw.history.col.status': 'Статус',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': 'Действия',
    'user.notifications.title': 'Уведомления',
    'inbox.summary': 'Всего {{total}} · непрочитанных {{unread}}',
    'inbox.refresh': 'Обновить',
    'inbox.markAllRead': 'Пометить всё прочитанным',
  },

  bn: {
    'user.deposit.title': 'জমা',
    'user.deposit.tab.crypto': 'ক্রিপ্টো জমা',
    'user.deposit.tab.evoucher': 'ই-ভাউচার',
    'user.deposit.network.label': 'নেটওয়ার্ক',
    'user.deposit.network.soon': 'শীঘ্রই',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': 'জমার ঠিকানা লোড হচ্ছে…',
    'user.deposit.crypto.checkForDeposit': 'জমা পরীক্ষা করুন',
    'user.deposit.crypto.checking': 'পরীক্ষা হচ্ছে…',
    'user.deposit.crypto.checkFound': 'নতুন জমা পাওয়া গেছে! নিশ্চিতকরণের অপেক্ষায়।',
    'user.deposit.crypto.checkNone': 'নতুন জমা নেই। কিছুক্ষণ পর আবার চেষ্টা করুন।',
    'user.deposit.card.title': 'আপনার জমার ঠিকানা',
    'user.deposit.card.sendOnly': 'শুধুমাত্র USDT TRC20 এই ঠিকানায় পাঠান',
    'user.deposit.card.networkLine': 'নেটওয়ার্ক: শুধু USDT TRC20',
    'user.deposit.card.confirmationsLine': '{{n}}টি নিশ্চিতকরণ প্রয়োজন (~১ মিনিট)',
    'user.deposit.card.valid24h': 'ঠিকানা ২৪ ঘণ্টা বৈধ',
    'user.deposit.card.warningWrongToken':
      'শুধু USDT TRC20 পাঠান। অন্য টোকেন বা নেটওয়ার্কে স্থায়ী ক্ষতি হতে পারে।',
    'user.deposit.card.scanQr': 'QR কোড স্ক্যান করুন',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': '{{h}}ঘ {{m}}ম {{s}}সে মেয়াদ শেষ',
    'user.deposit.expired': 'মেয়াদোত্তীর্ণ',
    'user.deposit.history.title': 'জমার ইতিহাস',
    'user.deposit.history.filter.all': 'সব',
    'user.deposit.history.filter.pending': 'বিচারাধীন',
    'user.deposit.history.filter.confirming': 'নিশ্চিত হচ্ছে',
    'user.deposit.history.filter.completed': 'সম্পন্ন',
    'user.deposit.history.filter.failed': 'ব্যর্থ',
    'user.deposit.history.col.date': 'তারিখ',
    'user.deposit.history.col.amount': 'পরিমাণ',
    'user.deposit.history.col.status': 'অবস্থা',
    'user.deposit.history.col.confirmations': 'নিশ্চিতকরণ',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': 'উত্তোলন',
    'user.withdraw.form.title': 'উত্তোলনের অনুরোধ',
    'user.withdraw.form.method': 'উত্তোলন পদ্ধতি',
    'user.withdraw.form.selectMethod': 'পদ্ধতি নির্বাচন করুন',
    'user.withdraw.form.walletAddress': 'ওয়ালেট ঠিকানা',
    'user.withdraw.form.request': 'অনুরোধ পাঠান',
    'user.withdraw.rules.title': 'উত্তোলনের নিয়ম',
    'user.withdraw.rules.cryptoMining': 'ক্রিপ্টো মাইনিং',
    'user.withdraw.rules.cryptoMiningPeriod': 'প্রতি ৩ মাস',
    'user.withdraw.rules.bullion': 'বুলিয়ন ট্রেড',
    'user.withdraw.rules.bullionPeriod': 'প্রতি ৮ মাস',
    'user.withdraw.rules.pharma': 'ফার্মাসিউটিক্যাল',
    'user.withdraw.rules.pharmaPeriod': 'প্ল্যানের মেয়াদ শেষে',
    'user.withdraw.rules.supported': 'সমর্থিত পদ্ধতি',
    'user.withdraw.rules.feeNote':
      'ওয়ালেট উত্তোলনে {{pct}}% প্ল্যাটফর্ম ফি প্রযোজ্য। আগাম প্ল্যান বাতিলের জন্য আলাদা ফি।',
    'user.withdraw.rules.noFeeNote':
      'ওয়ালেট উত্তোলনে প্ল্যাটফর্ম ফি নেই। আগাম প্ল্যান বাতিলের জন্য আলাদা ফি।',
    'user.withdraw.rules.processingNote':
      'অনুমোদনের পর ২৪–৪৮ ঘণ্টার মধ্যে আবেদন প্রক্রিয়াকৃত হয়।',
    'user.withdraw.history.title': 'উত্তোলনের ইতিহাস',
    'user.withdraw.history.exportCsv': 'CSV রপ্তানি',
    'user.withdraw.history.col.date': 'তারিখ',
    'user.withdraw.history.col.amount': 'পরিমাণ',
    'user.withdraw.history.col.method': 'পদ্ধতি',
    'user.withdraw.history.col.fee': 'ফি',
    'user.withdraw.history.col.net': 'নিট',
    'user.withdraw.history.col.status': 'অবস্থা',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': 'কর্ম',
    'user.notifications.title': 'বিজ্ঞপ্তি',
    'inbox.summary': 'মোট {{total}} · অপঠিত {{unread}}',
    'inbox.refresh': 'রিফ্রেশ',
    'inbox.markAllRead': 'সব পঠিত চিহ্নিত করুন',
  },

  hi: {
    'user.deposit.title': 'जमा',
    'user.deposit.tab.crypto': 'क्रिप्टो जमा',
    'user.deposit.tab.evoucher': 'ई-वाउचर',
    'user.deposit.network.label': 'नेटवर्क',
    'user.deposit.network.soon': 'जल्द आ रहा है',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadingAddress': 'जमा पता लोड हो रहा है…',
    'user.deposit.crypto.checkForDeposit': 'जमा जाँचें',
    'user.deposit.crypto.checking': 'जाँच हो रही है…',
    'user.deposit.crypto.checkFound': 'नया जमा मिला! पुष्टिकरण की प्रतीक्षा।',
    'user.deposit.crypto.checkNone': 'कोई नया जमा नहीं। कुछ देर बाद फिर कोशिश करें।',
    'user.deposit.card.title': 'आपका जमा पता',
    'user.deposit.card.sendOnly': 'केवल USDT TRC20 इस पते पर भेजें',
    'user.deposit.card.networkLine': 'नेटवर्क: केवल USDT TRC20',
    'user.deposit.card.confirmationsLine': '{{n}} पुष्टियाँ आवश्यक (~1 मिनट)',
    'user.deposit.card.valid24h': 'पता 24 घंटे वैध',
    'user.deposit.card.warningWrongToken':
      'केवल USDT TRC20 भेजें। अन्य टोकन या नेटवर्क पर स्थायी नुकसान हो सकता है।',
    'user.deposit.card.scanQr': 'QR कोड स्कैन करें',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expiresIn': '{{h}}घ {{m}}म {{s}}स में समाप्त',
    'user.deposit.expired': 'समाप्त',
    'user.deposit.history.title': 'जमा इतिहास',
    'user.deposit.history.filter.all': 'सभी',
    'user.deposit.history.filter.pending': 'लंबित',
    'user.deposit.history.filter.confirming': 'पुष्टि में',
    'user.deposit.history.filter.completed': 'पूर्ण',
    'user.deposit.history.filter.failed': 'विफल',
    'user.deposit.history.col.date': 'दिनांक',
    'user.deposit.history.col.amount': 'राशि',
    'user.deposit.history.col.status': 'स्थिति',
    'user.deposit.history.col.confirmations': 'पुष्टियाँ',
    'user.deposit.history.col.txid': 'TXID',
    'user.withdraw.title': 'निकासी',
    'user.withdraw.form.title': 'निकासी अनुरोध',
    'user.withdraw.form.method': 'निकासी विधि',
    'user.withdraw.form.selectMethod': 'विधि चुनें',
    'user.withdraw.form.walletAddress': 'वॉलेट पता',
    'user.withdraw.form.request': 'अनुरोध भेजें',
    'user.withdraw.rules.title': 'निकासी नियम',
    'user.withdraw.rules.cryptoMining': 'क्रिप्टो माइनिंग',
    'user.withdraw.rules.cryptoMiningPeriod': 'हर 3 महीने',
    'user.withdraw.rules.bullion': 'बुलियन ट्रेड',
    'user.withdraw.rules.bullionPeriod': 'हर 8 महीने',
    'user.withdraw.rules.pharma': 'फार्मास्यूटिकल्स',
    'user.withdraw.rules.pharmaPeriod': 'योजना अवधि समाप्ति पर',
    'user.withdraw.rules.supported': 'समर्थित तरीके',
    'user.withdraw.rules.feeNote':
      'वॉलेट निकासी पर {{pct}}% प्लेटफ़ॉर्म शुल्क लागू है। जल्दी प्लान रद्दीकरण पर अलग शुल्क।',
    'user.withdraw.rules.noFeeNote':
      'वॉलेट निकासी पर कोई प्लेटफ़ॉर्म शुल्क नहीं। जल्दी प्लान रद्दीकरण पर अलग शुल्क।',
    'user.withdraw.rules.processingNote':
      'स्वीकृति के बाद 24–48 घंटों में अनुरोध संसाधित होते हैं।',
    'user.withdraw.history.title': 'निकासी इतिहास',
    'user.withdraw.history.exportCsv': 'CSV निर्यात',
    'user.withdraw.history.col.date': 'दिनांक',
    'user.withdraw.history.col.amount': 'राशि',
    'user.withdraw.history.col.method': 'विधि',
    'user.withdraw.history.col.fee': 'शुल्क',
    'user.withdraw.history.col.net': 'शुद्ध',
    'user.withdraw.history.col.status': 'स्थिति',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': 'कार्रवाई',
    'user.notifications.title': 'सूचनाएँ',
    'inbox.summary': 'कुल {{total}} · अपठित {{unread}}',
    'inbox.refresh': 'रीफ़्रेश',
    'inbox.markAllRead': 'सभी पढ़ा चिह्नित करें',
  },
};
